export * from './clinical-tab';
export * from './order-info-tab';
export * from './insurance-tab';
export * from './other-tab';
export * from './patient-attestation-tab';
export * from './patient-tab';
export * from './prescriber-attestation-tab';
export * from './prescriber-tab';
export * from './review-tab';
export * from './service-request-all-fields';
export * from './service-request-field-reimbursement-manager-fields';
export * from './service-request-copay-claim-fields';
export * from './service-request-copay-enrollment-fields';
export * from './service-request-insurance-review-fields';
export * from './service-request-medebv-fields';
export * from './service-request-medepa-fields';
export * from './service-request-patient-resources-fields';
export * from './service-request-rxebv-fields';
export * from './service-request-rxepa-fields';
export * from './prescription-tab';
export * from './pharmacy-tab';

export enum StepNames {
  PATIENT = 'patient',
  INSURANCE = 'insurance',
  PRESCRIBER = 'prescriber',
  CLINICAL = 'clinical',
  PRESCRIPTION = 'prescription',
  PHARMACY = 'pharmacy',
  OTHER = 'other',
  ORDER_INFORMATION = 'LEQVIO ORDER INFORMATION',
  PATIENT_ATTESTATION = 'patient-attestation',
  PRESCRIBER_ATTESTATION = 'prescriber-attestation',
  REVIEW = 'review'
}
